<template>
    <div class="forum-wrapper">
        <div class="forum-layout">
            <!-- Main Column -->
            <div class="main-column">
                <!-- Forum Header -->
                <header class="forum-header">
                    <h1 class="typo-headline-4">Normas del Foro</h1>
                    
                    <!-- Link to forum index -->
                    <div class="forum-rules-link">
                        <router-link to="/app/forum" class="rules-link typo-button">
                            <i class="material-icons">forum</i>
                            Volver al Foro
                        </router-link>
                    </div>
                </header>

                <!-- Main Content -->
                <section class="forum-content">
                    <div class="rules-container">
                        <div class="rules-introduction">
                            <p>El foro de Eurekers es una herramienta pensada para que todos los usuarios puedan intercambiar dudas, opiniones, preocupaciones sobre el método y sistema de Eurekers, e incluso aportar conocimientos u ofrecer ideas para mejorar la página web.</p>
                            
                            <p>Los encargados de que se haga un correcto uso del foro son los moderadores; ellos son los responsables de que los comentarios mantengan un tono correcto y cortés, así como de la supervisión de la aplicación de unas normas generales:</p>
                        </div>

                        <div class="rules-list">
                            <div class="rule-item">
                                <div class="rule-number">1</div>
                                <div class="rule-content">
                                    <p>Que los mensajes, en cumplimiento de la LOPD, no contengan ningún tipo de información personal sobre los usuarios (no se deben publicar números de teléfono, e-mails, NIFs, etc...).</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">2</div>
                                <div class="rule-content">
                                    <p>No tenemos limitación en la longitud de los mensajes, así pues, intentemos evitar mensajes estilo SMS (q tal, xq no funciona?) o con faltas de ortografía, así como mensajes en MAYÚSCULAS. Según las normas de netiqueta se considera que se está gritando, además que dificulta la lectura <a href="https://es.wikipedia.org/wiki/Netiqueta" target="_blank" rel="noopener">https://es.wikipedia.org/wiki/Netiqueta</a></p>
                                    <p>Intentemos también no hacerlos demasiado largos, ya que además de quitar tiempo a los demás dan muy pocas ganas de leerlos. Tampoco dar las gracias si es posible. Estamos todos agradecidos.</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">3</div>
                                <div class="rule-content">
                                    <p>No se permitirá la publicación de enlaces o mensajes haciendo referencia a estrategias de otros operadores, empresas, otros cursos, productos de terceros, informaciones o artículos de opinión, que se aparten de nuestra esencia (por ejemplo: scalping, intradía, forex, futuros, macroeconomia, etc..) así como hilos que puedan contener publicidad.</p>
                                    <p>Desde Eurekers creemos que existen otros foros/blogs/webs donde poder conseguir esa información o debatir estrategias ajenas a la filosofía de Eurekers.</p>
                                    <p>El foro tiene una esencia más orientada a la formación, repaso y refuerzo del método, que no a debatir o comentar sistemas o productos externos a Eurekers.</p>
                                    <p>Hacer referencia a temas bursátiles no relacionados con la esencia de Eurekers, creemos que puede desviar la atención y entorpecer la labor formativa y didáctica del foro.</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">4</div>
                                <div class="rule-content">
                                    <p>Se recomienda el uso de los buscadores (<a href="http://www.eurekers.com/guia-bienvenida/buscadores" target="_blank" rel="noopener">http://www.eurekers.com/guia-bienvenida/buscadores</a>) tanto del tickers como del foro, antes de abrir un nuevo hilo, para intentar evitar temas duplicados que puedan entorpecer el seguimiento de una duda o un valor, así como repetir una misma pregunta en diferentes hilos.</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">5</div>
                                <div class="rule-content">
                                    <p>Con el objetivo de no confundir o entorpecer la labor formativa, se ruega no publicar "inventos" particulares, modificaciones y/o interpretaciones que no encajen en el método. Se intenta mantener un mismo criterio para facilitar la enseñanza y aplicación de los conceptos aprendidos en los cursos.</p>
                                    <p>Por supuesto cada inversor es libre de actuar y gestionar su cartera como considere oportuno si asume las consecuencias de ello.</p>
                                    <p>Desde Eurekers no se aprueban ni recomiendan los "inventos".</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">6</div>
                                <div class="rule-content">
                                    <p>Realizar acciones de SPAM está prohibido en cualquiera de sus formas.</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">7</div>
                                <div class="rule-content">
                                    <p>Las compras (incluyendo la organización de pedidos en conjunto), ventas y/o tasaciones no están permitidas.</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">8</div>
                                <div class="rule-content">
                                    <p>Está terminantemente prohibido el uso del foro como medio para la compra/venta de material ilegal, enlazar a lugares que lo contengan, descarga de mp3 y/o programas con copyright, tratar temas de desprotección de software y, en definitiva, para tratar cualquier tema que sea ilegal o de dudosa legalidad. En cualquier caso, Eurekers no se hace responsable de los comentarios de los usuarios.</p>
                                </div>
                            </div>

                            <div class="rule-item">
                                <div class="rule-number">9</div>
                                <div class="rule-content">
                                    <p>No está permitido compartir documentos, libros, artículos u otros materiales protegidos por derechos de autor (copyright). Aunque sea posible descargar estos materiales de Internet, compartirlos en la comunidad constituye una infracción de la ley de propiedad intelectual y puede acarrear problemas legales tanto para el usuario como para Eurekers.</p>
                                </div>
                            </div>
                        </div>

                        <div class="rules-conclusion">
                            <p>Si un usuario no hiciese un uso correcto de esta web, podrá ser bloqueado e incluso expulsado, por ello, intentemos mantener el espíritu y esencia de Eurekers, como una forma diferente de ver los mercados y la vida. Una visión que se nutre del conjunto de los Eurekers con esfuerzo, colaboración, formación, mentalidad adecuada, superación, actitud, entrega, alegría, ilusión, experiencia, constancia, energía, esperanza, habilidad, crecimiento, conocimiento, ambición, ingenio, éxito y pasión.</p>
                            
                            <p>Al utilizar el foro, acepta todos los términos sin condiciones; en caso contrario los administradores y/o responsables del sitio harán uso del derecho de admisión, cancelando su cuenta o tomando las medidas oportunas.</p>
                        </div>
                    </div>
                </section>
            </div>

            <!-- Side Column -->
            <div class="side-column">
                <!-- Admin Activity Widget -->
                <admin-activity-widget />

                <!-- User Activity Widget -->
                <user-activity-widget />

                <!-- Forum Stats -->
                <forum-stats-container />
            </div>
        </div>
    </div>
</template>

<script>
import ForumStatsContainer from './components/ForumStatsContainer.vue';
import UserActivityWidget from './components/UserActivityWidget.vue';
import AdminActivityWidget from './components/AdminActivityWidget.vue';

export default {
    name: 'ForumRules',
    components: {
        ForumStatsContainer,
        UserActivityWidget,
        AdminActivityWidget,
    }
};
</script>

<style scoped>
/* Contenedor general */
.forum-wrapper {
    background-color: var(--color-background);
    min-height: 100vh;
    padding: 40px 20px;
}

/* Layout de dos columnas */
.forum-layout {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    gap: 20px;
}

/* Estilos de la columna principal */
.main-column {
    flex: 3;
    color: var(--color-text-primary);
}

/* Cabecera del foro */
.forum-header {
    margin-bottom: 20px;
    padding: 20px;
    background-color: var(--color-surface);
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    align-items: center;
}

.forum-header h1 {
    margin: 0;
}

.forum-rules-link {
    margin-top: 10px;
}

.rules-link {
    display: flex;
    align-items: center;
    gap: 5px;
    color: var(--color-highlight);
    text-decoration: none;
    padding: 8px 16px;
    border-radius: 4px;
    transition: background-color 0.3s ease;
}

.rules-link:hover {
    background-color: var(--color-active-surface);
}

.rules-link i {
    font-size: 18px;
}

/* Contenido principal */
.forum-content {
    margin-bottom: 20px;
}

/* Contenedor de reglas */
.rules-container {
    background-color: var(--color-surface);
    border-radius: 15px;
    padding: 30px;
    color: var(--color-text-primary);
}

/* Introducción a las reglas */
.rules-introduction {
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid var(--color-outline);
}

.rules-introduction p {
    margin-bottom: 15px;
    line-height: 1.6;
}

/* Lista de reglas */
.rules-list {
    display: flex;
    flex-direction: column;
    gap: 25px;
    margin-bottom: 30px;
}

/* Cada regla individual */
.rule-item {
    display: flex;
    gap: 15px;
    align-items: baseline;
}

.rule-number {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    background-color: var(--color-highlight);
    color: white;
    border-radius: 50%;
    font-weight: bold;
    font-size: 20px;
    flex-shrink: 0;
    margin-top: 5px;
}

.rule-content {
    flex: 1;
    padding-top: 5px;
}

.rule-content p {
    margin-bottom: 10px;
    line-height: 1.6;
}

.rule-content a {
    color: var(--color-highlight);
    text-decoration: none;
}

.rule-content a:hover {
    text-decoration: underline;
}

/* Conclusión de las reglas */
.rules-conclusion {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid var(--color-outline);
}

.rules-conclusion p {
    margin-bottom: 15px;
    line-height: 1.6;
}

/* Columna lateral */
.side-column {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

/* Responsividad */
@media (max-width: 768px) {
    .forum-layout {
        flex-direction: column;
    }
    
    .main-column,
    .side-column {
        flex: 1;
        width: 100%;
    }
    
    .side-column {
        margin-top: 20px;
    }

    .rule-item {
        flex-direction: column;
        gap: 10px;
    }

    .rule-number {
        align-self: flex-start;
    }
}
</style> 